import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FJ211 {
  fj211_01: string;
  fj211_02: number;      // 加工代號
  fj211_11: string;      // 項次
  fj211_12: string;      // (sub-code)
  fj211_13: number;      // 產品代號 NUMERIC
  fj211_14: number;      // (col4) NUMERIC
  fj211_15: number;      // 預估成本(NT$)
  fj211_16: number;      // 費用率%
  fj211_17: string;      // 毛利率%
  fj211_18: string;      // 產品名稱
  fj211_19: string;      // 成品組織/規格
  fj211_20: string;      // 加工別
  fj211_21: number;      // 針孔內
  fj211_22: number;      // 針孔外
  fj211_23: number;      // 碼重
  fj211_24: number;      // 米平方重
  fj211_25: string;      // 建議售價(US$)
  fj211_261: string;     // 報告單號1
  fj211_262: string;     // 報告單號2
  fj211_263: string;     // 報告單號3
  fj211_27: boolean;     // 是否為暢銷品
}

export interface FJ210 {
  fj210_01: string;          // 專輯編號 (PK)
  fj210_11: string | null;   // 製作日期
  fj210_12: string;          // 專輯主題
  fj210_13: string;          // 製作人員
  fj210_14: number;          // 製作份數
  fj210_15: string;          // 公司名稱
  fj210_16: number;          // 預估匯率
  fj210_17: string;          // 交易條件
  fj210_18: number;          // 專輯類別
  fj210_20: number;          // 總項數
  fj210_21: string;          // 備註
  fj210_23: string;          // 專輯抬頭日期
  fj210_80: string;          // 狀態
  fj210_92: string | null;   // 更新時間
  details?: FJ211[];
}

export interface FJ211Input {
  fj211_02?: number;
  fj211_11: string;
  fj211_12: string;
  fj211_13: number;
  fj211_14: number;
  fj211_15: number;
  fj211_16: number;
  fj211_17: string;
  fj211_18: string;
  fj211_19: string;
  fj211_20: string;
  fj211_21: number;
  fj211_22: number;
  fj211_23: number;
  fj211_24: number;
  fj211_25: string;
  fj211_261: string;
  fj211_262: string;
  fj211_263: string;
  fj211_27: boolean;
}

export interface CreateJ212Request {
  fj210_11?: string | null;  // 製作日期
  fj210_12: string;          // 專輯主題
  fj210_13: string;          // 製作人員
  fj210_14: number;          // 製作份數
  fj210_15: string;          // 公司名稱
  fj210_16: number;          // 預估匯率
  fj210_17: string;          // 交易條件
  fj210_18: number;          // 專輯類別
  fj210_21: string;          // 備註
  fj210_23: string;          // 專輯抬頭日期
  fj210_80: string;          // 狀態
  details: FJ211Input[];
}

export interface UpdateJ212Request extends CreateJ212Request {}

export interface ListJ212Response {
  data: FJ210[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

const BASE = '/api/j212';

export const j212Api = {
  async list(page = 1, size = 200, keyword?: string): Promise<ListJ212Response> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get(BASE, { params });
    return res.data;
  },

  async getByID(id: string): Promise<FJ210> {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: CreateJ212Request): Promise<FJ210> {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  async update(id: string, data: UpdateJ212Request): Promise<FJ210> {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${BASE}/${encodeURIComponent(id)}`);
  },
};
